import type {ReactElement, ReactNode} from 'react';
import {Tooltip, TooltipContent, TooltipTrigger} from '@/components/ui/Tooltip';

/** Shows a dictionary explanation on hover (or keyboard focus) of `children`,
 * keeping the explanation text itself off the page until it's wanted. Needs
 * a TooltipProvider above it (EdiViewerPage provides one). */
export function Explain({
  content,
  children,
}: {
  content: ReactNode;
  children: ReactElement;
}) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side="top" align="start">
        {content}
      </TooltipContent>
    </Tooltip>
  );
}
